module.exports = __webpack_public_path__ + "img/blue_087.a0717481.png";